import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { trackSectionView, trackFeatureUsage } from '../utils/analytics';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackSectionView('faq_section');
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const faqs = [
    {
      question: "Qu'est-ce qu'un spot panoramique ?",
      answer: "Un spot panoramique est un lieu offrant une vue exceptionnelle, un point de vue unique ou simplement un endroit paisible pour se ressourcer. Cela peut être un banc avec vue, un sommet, un lac caché, ou tout lieu qui procure un sentiment de sérénité et d'émerveillement."
    },
    {
      question: "Comment fonctionne Sun-Spot ?",
      answer: "Sun-Spot permet de découvrir des lieux exceptionnels près de chez vous grâce aux recommandations de la communauté. Chaque spot est documenté avec des photos, des informations pratiques (accès, parking, meilleure période) et des conseils d'autres visiteurs."
    },
    {
      question: "L'application est-elle vraiment gratuite ?",
      answer: "Oui, absolument ! Sun-Spot est et restera toujours 100% gratuit. Notre mission est de démocratiser l'accès aux merveilles naturelles et de créer du lien social autour de la découverte de lieux authentiques."
    },
    {
      question: "Comment puis-je contribuer ?",
      answer: "Vous pouvez partager vos spots préférés en les documentant avec soin : photos, description, conseils pratiques. Plus la communauté grandit, plus nous découvrons ensemble de lieux extraordinaires à portée de main."
    },
    {
      question: "Les spots sont-ils vérifiés ?",
      answer: "Chaque spot partagé est validé par la communauté. Nous encourageons les retours d'expérience et les mises à jour pour maintenir des informations fiables et actualisées."
    }
  ];

  const toggleFaq = (index) => {
    const newIndex = openIndex === index ? null : index;
    setOpenIndex(newIndex);
    
    if (newIndex !== null) {
      trackFeatureUsage('faq_open', 'click');
    }
  };

  return (
    <section ref={sectionRef} className="py-20 bg-white/30 backdrop-blur-sm">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-amber-800 mb-6">
            Questions fréquentes
          </h2>
          <p className="text-xl text-gray-700">
            Tout ce que vous devez savoir sur Sun-Spot
          </p>
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white/60 backdrop-blur-md rounded-xl overflow-hidden">
              <button
                className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-white/70 transition-colors duration-200"
                onClick={() => toggleFaq(index)}
              >
                <span className="text-lg font-semibold text-amber-800 pr-4">
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <ChevronUp className="w-6 h-6 text-amber-600 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-amber-600 flex-shrink-0" />
                )}
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;